import loadGoogleMapsApi from 'load-google-maps-api';

class Maps {
  constructor(apikey, clientid) {
    this.key = apikey;
    this.clientid = clientid;
    const gmap = document.getElementById('location_googlemap');
    const mapstyles = {
      'DarkStyle': "7af77392fd7c10e0"
    }
    this.latlng = gmap.dataset.latlng;
    // Only execute from here if Google Map container & latlng exist
    if(!gmap) return false;
    if(!this.latlng) return false;

    this.map;
    this.marker;
    this.placedata;
    this.service;
    this.mapid = mapstyles[gmap.dataset.style] || "";
    this.searchterm = gmap.dataset.search;
    this.zoom = gmap.dataset.zoom;
    this.init();
  }

  init() {
    if(this.latlng == "") {
      this.mapFromAddress();
    } else {
      this.mapFromLatLng();
    }
  }

  /**
   * Gets GMap from latlng coordinates
   */
  mapFromLatLng() {
    const location = this.getLatLngObject();
    loadGoogleMapsApi({
      'key': this.key,
      'libraries': ['places']
    }).then( googleMaps => {
      this.createMap(googleMaps, location.lat, location.lng, this.mapid)
    }).catch(function (error) {
      console.error(error)
    })
  }

  createMap(maps, lat, lng, mapid) {
    this.map = new maps.Map(document.querySelector('#location_googlemap'), {
      zoom: parseInt(this.zoom) || 15,
      center: {
        lat: lat,
        lng: lng
      },
      mapId: mapid

    });

    this.marker = new maps.Marker({
      position: {
        lat: lat,
        lng: lng
      },
      map: this.map,
    });
    this.getPlaceData(maps);
  }
  /**
   *
   * @returns GoogleMaps LatLng object
   */
  getLatLngObject() {
    const arr = this.latlng.split(',');
    return {
      lat: parseFloat(arr[0]),
      lng: parseFloat(arr[1])
    }
  }

  /**
   * Gets place data from GMaps
   * Fills in details for map box
   * @param {GoogleMap} maps
   */
  getPlaceData(maps) {
    const request = {
      query: this.searchterm,
      fields: [
        'place_id',
        'name',
        'geometry'
      ]
    }

    this.service = new maps.places.PlacesService(this.map);

    // const details = this.service.getDetails()
    this.service.findPlaceFromQuery(request, (results, status) => {
      if (status === maps.places.PlacesServiceStatus.OK) {
        const detailsRequest = {
          'placeId': results[0].place_id,
          'fields': [
            'opening_hours',
            'utc_offset_minutes',
            'formatted_address',
            'international_phone_number',
            'url'
          ]
        }
        const details = this.service.getDetails(detailsRequest, (place, status) => {
          const elBusinessName = document.getElementById('business_name');
          const elStatus = document.querySelector('.block-map__address--status');
          const elNext = document.querySelector('.block-map__address--nextstatus');
          const elAddress = document.getElementById('location_streetaddress');
          const elPhone = document.querySelector('.block-map__address--phone');
          const elLink = document.querySelector('.block-map__address--get-directions a');

          if(status == 'OK') {
            elBusinessName.innerText = results[0].name;
            elAddress.innerText = place.formatted_address;
            elPhone.innerText = place.international_phone_number;
            elLink.setAttribute('href', place.url);
            if(place && place.opening_hours) {
                const oh = place.opening_hours;
                elStatus.innerText = oh.isOpen() ? 'Open' : 'Closed';
                elNext.innerText = this.getNextHours(oh.periods, oh.isOpen());
            }
          }
        });
      }
    });
  }

  /**
   * Calculates opening hours for store
   *
   * @param {Array} periods
   * @param {Boolean} is_open
   * @returns {String} Open/Closed and Next open
   */
  getNextHours(periods, is_open) {
    // periods array starts on Monday, Date::getDay starts on Sunday
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ];
    const now = new Date();
    const dayIndex = now.getDay();
    const day = days[dayIndex];
    const periodsIndex = dayIndex == 0 ? 6 : dayIndex - 1;
    const hours = periods[periodsIndex];

    // Sunday will return undefined for hours as they are not listed in GMaps
    if(hours === undefined) { // today is Sunday
      const nextTime = new Date(periods[0].open.nextDate);
      const hour = nextTime.getHours();
      return 'Opens '
              + days[nextTime.getDay()] + ", "
              + (hour > 12 ? hour - 12 : hour)
              + ":"
              + nextTime.getMinutes()
              + (hour < 12 ? 'am' : 'pm');
    }
    // Otherwise work out the opening/closing time
    const nextTime = is_open ? new Date(periods[periodsIndex].close.nextDate) : new Date(periods[periodsIndex].open.nextDate);
    const hour = nextTime.getHours();

    return (is_open ? 'Closes ' : 'Opens ')
          + (is_open ? '' : days[nextTime.getDay()] + ", ")
          + (hour > 12 ? hour - 12 : hour)
          + ":"
          + (nextTime.getMinutes().toString().length === 1 ? "0" + nextTime.getMinutes() : nextTime.getMinutes())
          + (hour < 12 ? 'am' : 'pm');

  }
}

export default Maps;
